"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_DOMAIN = exports.AUTO_GENERATED_EMAIL_PREFIX = void 0;
exports.formatUpdateBookingFormDataForApi = formatUpdateBookingFormDataForApi;
exports.formatDatesForApi = formatDatesForApi;
exports.getInitialDatesValue = getInitialDatesValue;
exports.getInitialGroupPayMembersValue = getInitialGroupPayMembersValue;
exports.getMinMaxGuestsAndAvailableSlots = getMinMaxGuestsAndAvailableSlots;
exports.formatGroupPayMembersForApi = formatGroupPayMembersForApi;
exports.isUpdateBookingSubmitButtonDisabled = isUpdateBookingSubmitButtonDisabled;
exports.getIsAutoGeneratedEmail = getIsAutoGeneratedEmail;
const date_fns_1 = require("date-fns");
const common_helpers_1 = require("./common-helpers");
exports.AUTO_GENERATED_EMAIL_PREFIX = "offsite.booking+";
exports.EMAIL_DOMAIN = "@mallardbay.com";
function formatUpdateBookingFormDataForApi({ dates, groupPayHost, groupPayMembers, numberOfGuests, }) {
    const formattedDates = formatDatesForApi(dates);
    const formattedGroupPayHost = groupPayHost
        ? formatGroupPayMemberForApi(groupPayHost)
        : null;
    const formattedGroupPayMembers = formatGroupPayMembersForApi(groupPayMembers);
    return {
        dates: formattedDates,
        groupPayHost: formattedGroupPayHost,
        groupPayMembers: formattedGroupPayMembers,
        numberOfGuests,
    };
}
function formatDatesForApi(dates) {
    const [startDate, endDate] = dates;
    if (!startDate)
        return [];
    if (!endDate)
        return [startDate.getTime()];
    const numberOfDays = (0, date_fns_1.differenceInDays)(endDate, startDate) + 1;
    return (0, common_helpers_1.getArrayOfCount)(numberOfDays).map((dayOffset) => (0, date_fns_1.addDays)(startDate, dayOffset).getTime());
}
function getInitialDatesValue(booking) {
    return [new Date(booking.start_date), new Date(booking.end_date)];
}
function getInitialGroupPayMembersValue(booking) {
    var _a, _b;
    const shares = (_b = (_a = booking.group_pay_share) === null || _a === void 0 ? void 0 : _a.shares) !== null && _b !== void 0 ? _b : [];
    const memberShares = shares.filter((share) => !share.is_host);
    return memberShares.map(({ member, slots }) => ({
        email: member.email,
        id: member.id,
        name: member.name,
        slots,
    }));
}
function getMinMaxGuestsAndAvailableSlots({ groupPayHost, groupPayMembers, numberOfGuests, pricingPackage, }) {
    var _a, _b;
    const minGuests = (_a = pricingPackage === null || pricingPackage === void 0 ? void 0 : pricingPackage.min_guests) !== null && _a !== void 0 ? _a : 1;
    const maxGuests = (_b = pricingPackage === null || pricingPackage === void 0 ? void 0 : pricingPackage.max_guests) !== null && _b !== void 0 ? _b : numberOfGuests;
    const slotsAvailableForMembers = calculateAvailableSlots({
        groupPayHost,
        groupPayMembers,
        numberOfGuests,
    });
    return { maxGuests, minGuests, slotsAvailableForMembers };
}
function calculateAvailableSlots({ groupPayHost, groupPayMembers, numberOfGuests, }) {
    var _a;
    const hostSlots = (_a = groupPayHost === null || groupPayHost === void 0 ? void 0 : groupPayHost.slots) !== null && _a !== void 0 ? _a : 0;
    const totalSlotsCoveredByMembers = groupPayMembers.reduce((count, member) => count + member.slots, 0);
    const totalSlotsCovered = totalSlotsCoveredByMembers + hostSlots;
    return numberOfGuests - totalSlotsCovered;
}
function formatGroupPayMembersForApi(groupPayMembers) {
    return groupPayMembers.map(formatGroupPayMemberForApi);
}
function isUpdateBookingSubmitButtonDisabled({ dates, slotsAvailableForMembers, }) {
    return dates.length === 0 || slotsAvailableForMembers < 0;
}
function formatGroupPayMemberForApi({ id, slots }) {
    return { id, slots };
}
function getIsAutoGeneratedEmail(email) {
    if (!email)
        return false;
    return (email.startsWith(exports.AUTO_GENERATED_EMAIL_PREFIX) &&
        email.endsWith(exports.EMAIL_DOMAIN));
}
